// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Gk-z","tupacHeader":"Hk-z","tupacHeader2":"Ik-z","tupacMenu":"Jk-z","tupacMenu2":"Kk-z","tupacMain":"Lk-z","tupacMain2":"Mk-z"};